/** @jsx h */
import { h } from 'preact'
import Poll from './Poll'

const PollContainer = ({ data, votingUrl, accountUrl }) => (
  <Poll {...data} votingUrl={votingUrl} accountUrl={accountUrl} />
)

export default PollContainer
